import React from "react";
import type { FC } from "react";

import { UniBoxAdditionalBaseSlot } from "../components/Slot/UniBoxAdditionalSlot";

import type {
    UniBoxAdditionalSlotProps,
    SlotTypes,
} from "../components/Slot/types";

import classes from "../components/Slot/UniBoxAdditionalSlot.styl";

type SlotFactoryArgs<SlotType extends SlotTypes> = {
    slotType: SlotType;
    displayName: string;
    defaultTsid: string;
};

export const slotFactory = <SlotType extends SlotTypes>({
    displayName,
    defaultTsid,
    slotType,
}: SlotFactoryArgs<SlotType>) => {
    const FactorySlot: FC<UniBoxAdditionalSlotProps> = ({
        children,
        "data-tsid": tsid,
        ...props
    }) => {
        const classNames = classes[`__${slotType}`];

        return (
            <UniBoxAdditionalBaseSlot
                data-tsid={tsid || defaultTsid}
                className={classNames}
                {...props}
            >
                {children}
            </UniBoxAdditionalBaseSlot>
        );
    };

    FactorySlot.displayName = displayName;

    return FactorySlot;
};
